import {
  ThematicPackageBudgetTierIds,
  CampaignSubmitResponse,
} from '@features/campaigns/shared/types/campaignSubmit.ts';
import { mockedCampaignDetails } from '@shared/mocks/requests/campaignDetails/campaignDetails.fixtures';

export const mockedCampaignSubmitResponse = {
  campaign: mockedCampaignDetails,
  thematicPackageUpsell: {
    isEligible: true,
    budgetTiers: [
      { id: ThematicPackageBudgetTierIds.TIER_1, amount: 500 },
      { id: ThematicPackageBudgetTierIds.TIER_2, amount: 1000 },
      { id: ThematicPackageBudgetTierIds.TIER_3, amount: 1500 },
    ],
    customBudget: {
      isAvailable: true,
      minimumAmount: 500,
      maximumAmount: null,
    },
  },
} satisfies CampaignSubmitResponse;
